<div class="testimonials-panel">
  <top-wave *ngIf="topWave"></top-wave>

  <div
    [class.testimonials-panel__content--link]="data.link"
    class="testimonials-panel__content"
  >
    <h2
      [class.testimonials-panel__title--big-pictures]="data.bigPictures.value"
      class="testimonials-panel__title"
      #titleEl
    >{{ data.title.value }}</h2>

    <div class="testimonials-panel__slider" #wrapper>
      <div
        [class.splide--big-pictures]="isBigPictures"
        class="splide splide--testimonials"
        #splide
      >
        <div class="splide__track">
          <ul class="splide__list">
            <li *ngFor="let item of items; let i = index;" class="splide__slide">
              <div
                class="testimonials-panel__card"
                [class.testimonials-panel__card--big]="data.bigPictures.value"
                [class.testimonials-panel__card--normal]="!data.bigPictures.value"
                [class.testimonials-panel__card--background-active]="i === current && isReadMoreActive"
              >
                <div
                  *ngIf="item && item.media?.value"
                  class="testimonials-panel__media-container"
                  [class.testimonials-panel__media-container--big]="data.bigPictures.value"
                  [class.testimonials-panel__media-container--normal]="!data.bigPictures.value"
                >
                  <div *ngTemplateOutlet="item.media.value.image ? imageBlock : videoBlock; context: { item: item }"></div>
                </div>
                <!-- Text content -->
                <div [ngClass]="{'testimonials-panel--text-on-top slide-in-transition': data.bigPictures.value}">
                  <app-testimonials-panel-info
                    [item]="item"
                    [forceHideQuoteId]="forceHideQuoteId"
                    (readMoreActivated)="onReadMoreActivated()"
                  ></app-testimonials-panel-info>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div *ngIf="data.link?.value" class="testimonials-panel__link">
      <app-bg-button
        [data]="data.link.value"
        [buttonColor]="data.linkColor.value"
      ></app-bg-button>
    </div>
  </div>

  <bottom-wave *ngIf="bottomWave"></bottom-wave>
</div>

<ng-template #imageBlock let-item="item">
  <div class="testimonials-panel__portrait">
    <img
      [src]="isMobile ? item.imageData.mobileSrc : item.imageData.desktopSrc"
      [alt]="isMobile ? item.imageData.mobileAlt : item.imageData.desktopAlt"
      loading="lazy"
      [ngStyle]="{aspectRatio: item.imageData?.width / item.imageData?.height}"
    />
  </div>
</ng-template>

<ng-template #videoBlock let-item="item">
  <div
    *ngIf="item.videoData"
    (click)="openVideoModal(item)"
    class="testimonials-panel__portrait testimonials-panel__thumbnail"
    >
    <div class="testimonials-panel__thumbnail-img">
      <img src="{{ item.videoData.thumbnail.src }}"
      alt=""
      [ngStyle]="{aspectRatio: item.videoData?.thumbnail?.width / item.videoData?.thumbnail?.height}" />
    </div>

    <div class="testimonials-panel__thumbnail-play-button" (click)="openVideoModal(item)"></div>
  </div>
</ng-template>

<ng-container *ngFor="let item of items">
  <app-modal-video
    *ngIf="item.isShow"
    [isShow]="item.isShow"
    [data]="item.videoData"
    (close)="closeVideoModal(item)"
    class="testimonials-panel__modal"
  ></app-modal-video>
</ng-container>
